<template>
  <v-navigation-drawer app temporary overlay-opacity="0" right width="400" @input="clickOutside" v-model="drawer">
    <v-container ref="drawerHeader">
      <v-row class="ml-1">
        <v-col>
          <p class="d-flex justify-space-between align-center">
            <v-btn v-if="$vuetify.breakpoint.xs"
              text
              class="pl-0"
              color="#505d69"
              @click="toggleNotificationDrawer">
              <i class="mdi mdi-close" style="font-size: 30px"></i>
              <span style="font-size: medium">{{ $t('fields.header.drawer.notifications') }}</span>
            </v-btn>
            <span v-else>{{ $t('fields.header.drawer.notifications') }}</span>
            <v-btn @click="markAllAsRead" color="#5664d2" text>
              <span style="font-size: small">
                {{ $t('fields.header.drawer.markAsRead')}}
                <i class="mdi mdi-check-circle-outline"></i>
              </span>
            </v-btn>
          </p>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <v-tabs v-model="tab">
            <v-tab v-for="tab in drawerNotificationTabs" :key="tab.key">{{ $tc(tab.label, tab.counter, {'count': tab.counter}) }}</v-tab>
          </v-tabs>
        </v-col>
      </v-row>
    </v-container>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="tab in drawerNotificationTabs" :key="tab.key">
        <v-list :height="drawerContentHeight" class="overflow-y-auto">
          <v-list-item
            v-for="(item, i) in tab.items"
            :key="i"
          >
            <v-list-item-icon :class="iconNotificationColors(item.type)">
              <v-badge :value="!item.read_at" bordered dot left color="#90CDF4">
                <v-btn fab small>
                  <v-icon class="mdi icon-type-notification">{{ iconNotificationType(item.type) }}</v-icon>
                </v-btn>
              </v-badge>
            </v-list-item-icon>
            <v-list-item-content>
              <div class="notification">
                <div @click.stop="checkAsReadAndGo(item.id)">
                  <v-list-item-title>{{ item.data.title || '' }}</v-list-item-title>
                  <p class="my-3 text-muted">{{ item.data.text || '-' }}</p>
                  <p class="text-muted">
                    <i class="mdi mdi-clock-outline mr-1"></i>
                    {{ formatDate(item.created_at) || '00:00' }}
                  </p>
                </div>
              </div>
            </v-list-item-content>
            <v-list-item-action v-if="!item.read_at">
              <v-btn icon @click.stop="checkAsRead({ 'notificationId': item.id })">
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-tab-item>
    </v-tabs-items>
  </v-navigation-drawer>
</template>

<script>
import moment from 'moment'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'NotificationDrawer',
  data: function () {
    return {
      tab: 'all',
      notifications: [],
      drawerHeaderHeight: 0
    }
  },
  created: function () {
    moment.locale(this.$i18n.locale)
    this.getNotifications()
    this.getNotificationsUnread()
    this.getNotificationsRead()
  },
  mounted () {
    this.updateDrawerHeaderHeight()
    window.addEventListener('resize', this.updateDrawerHeaderHeight)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateDrawerHeaderHeight)
  },
  methods: {
    ...mapMutations([
      'toggleNotificationDrawer'
    ]),
    ...mapActions([
      'getNotifications',
      'getNotificationsUnread',
      'getNotificationsRead',
      'checkAsRead',
      'markAllAsRead'
    ]),
    formatDate: function (date) {
      return moment(date).format('LLL')
    },
    clickOutside: function (drawer) {
      if (drawer !== this.showNotificationDrawer) {
        this.toggleNotificationDrawer()
      }
    },
    navigateTo () {
      this.$router.push('/notifications')
    },
    checkAsReadAndGo: function (id) {
      this.checkAsRead({ 'notificationId': id })
        .then(({ url }) => {
          window.location.href = url
        })
    },
    updateDrawerHeaderHeight () {
      this.$nextTick(() => {
        this.drawerHeaderHeight = this.$refs.drawerHeader.clientHeight || 0
      })
    },
    iconNotificationColors: function (type) {
      switch (type) {
        case 'App\\Notifications\\BookingClient':
        case 'App\\Notifications\\BookingClientLegal':
        case 'App\\Notifications\\BookingClientOperations':
        case 'App\\Notifications\\BookingConfirmationRequest':
        case 'App\\Notifications\\OptionConsolidatedBooking':
          return 'file-notification-type'

        case 'App\\Notifications\\AforderFileUploaded':
          return 'attach-notification-type'

        case 'App\\Notifications\\AforderRemark':
        case 'App\\Notifications\\RemarkInvoice':
          return 'chat-notification-type'

        default:
          return 'mail-notification-type'
      }
    },
    iconNotificationType: function (type) {
      switch (type) {
        case 'App\\Notifications\\BookingClient':
        case 'App\\Notifications\\BookingClientLegal':
        case 'App\\Notifications\\BookingClientOperations':
        case 'App\\Notifications\\BookingConfirmationRequest':
        case 'App\\Notifications\\OptionConsolidatedBooking':
          return 'mdi-file-document'

        case 'App\\Notifications\\AforderFileUploaded':
          return 'mdi-paperclip'

        case 'App\\Notifications\\AforderRemark':
        case 'App\\Notifications\\RemarkInvoice':
          return 'mdi-message-text'

        default:
          return 'mdi-email-outline'
      }
    }
  },
  computed: {
    ...mapState([
      'user',
      'drawerNotifications',
      'drawerNotificationsUnread',
      'drawerNotificationsRead',
      'showNotificationDrawer',
      'processingNotificationQueue',
      'unreadNotificationCounter',
      'readNotificationCounter'
    ]),
    drawer: {
      get: function () {
        return this.showNotificationDrawer
      },
      set: function (value) {
        this.toggleNotificationDrawer(value)
      }
    },
    drawerNotificationTabs: function () {
      return [
        { key: 'all', label: 'fields.header.drawer.all', items: this.drawerNotifications },
        { key: 'unread', label: 'fields.header.drawer.unread', counter: this.unreadNotificationCounter, items: this.drawerNotificationsUnread },
        { key: 'read', label: 'fields.header.drawer.read', counter: this.readNotificationCounter, items: this.drawerNotificationsRead }
      ]
    },
    drawerContentHeight: function () {
      return this.$vuetify.breakpoint.height - this.drawerHeaderHeight
    }
  },
  watch: {
    'user.id': function (newValue) {
      if (newValue) {
        this.getNotifications()
        this.getNotificationsUnread()
        this.getNotificationsRead()
      }
    },
    processingNotificationQueue (newValue) {
      if (newValue === false) {
        this.getNotificationsUnread()
        this.getNotificationsRead()
      }
    }
  }
}
</script>

<style scoped>
.v-navigation-drawer {
  margin-top: 0px !important;
  margin-left: 0px !important;
}

.v-list-item__content {
  padding: 16px 0px !important;
  font-size: 14px !important;
}

.v-list-item__title {
  font-weight: 600 !important;
  font-size: 14px !important;
}

.notification {
  display: inline-flex;
}

.icon-type-notification {
  font-size: 30px;
}

.file-notification-type button {
  color: white;
  background-color: #74C8CA !important;
}

.attach-notification-type button {
  color: white;
  background-color: #315455 !important;
}

.chat-notification-type button {
  color: #101820;
  background-color: #EDE939 !important;
}

.mail-notification-type button {
  color: #505669;
  background-color: #E7E8E9 !important;
}
</style>
